/**
 * 身份与权限管理 API 封装。
 * 统一走 /core-api/api/v1/identity，身份头来自 legacy 登录态。
 *
 * 后端接口对应 IdentityController.java。
 */
import $ from "jquery";
import coreApiRoot from "@/utils/coreApiRoot";

const root = coreApiRoot() + "/api/v1/identity";

function headers() {
  return {
    "X-Legacy-Tenant-Id": localStorage.getItem("UserComSysno") || "OKR-DEMO-COMPANY",
    "X-Legacy-User-Id": localStorage.getItem("UserSysno") || "OKR-DEMO-USER"
  };
}

function request(method, path, data) {
  // GET 请求：过滤 null / undefined / 空字符串参数，避免 jQuery 把它们序列化成 ?key=（空串）
  // 导致后端 @RequestParam 收到 "" 而非 null，触发校验异常
  const payload = method === "GET" && data && typeof data === "object"
    ? Object.fromEntries(Object.entries(data).filter(([, v]) => v !== null && v !== undefined && v !== ""))
    : data;
  return new Promise((resolve, reject) => $.ajax({
    type: method,
    url: root + path,
    headers: headers(),
    contentType: "application/json; charset=UTF-8",
    dataType: "json",
    data: method === "GET" ? payload : JSON.stringify(payload || {}),
    success: resolve,
    error(xhr) {
      const body = xhr.responseJSON || {};
      reject(new Error(body.message || "权限服务暂时不可用"));
    }
  }));
}

export default {
  // —— 权限目录 ——
  permissionCatalog() { return request("GET", "/permissions"); },

  // —— 组织 ——
  listOrganizations() { return request("GET", "/organizations"); },
  organizationTree() { return request("GET", "/organizations/tree"); },
  getOrganization(id) { return request("GET", `/organizations/${id}`); },
  createOrganization(data) { return request("POST", "/organizations", data); },
  updateOrganization(id, data) { return request("PUT", `/organizations/${id}`, data); },
  setOrganizationStatus(id, status) { return request("PUT", `/organizations/${id}/status`, { status }); },

  // —— 员工 ——
  listEmployees(orgId, query, status) { return request("GET", "/employees", { organizationId: orgId, query, status }); },
  getEmployee(id) { return request("GET", `/employees/${id}`); },
  createEmployee(data) { return request("POST", "/employees", data); },
  updateEmployee(id, data) { return request("PUT", `/employees/${id}`, data); },
  setEmployeeStatus(id, status) { return request("PUT", `/employees/${id}/status`, { status }); },
  setEmployeeBrandPost(id, brandPost) { return request("PUT", `/employees/${id}/brand-post`, { brandPost }); },
  headImages() { return request("GET", "/employees/head-images"); },

  // —— 角色 ——
  listRoles() { return request("GET", "/roles"); },
  getRole(id) { return request("GET", `/roles/${id}`); },
  createRole(data) { return request("POST", "/roles", data); },
  updateRole(id, data) { return request("PUT", `/roles/${id}`, data); },
  deleteRole(id) { return request("DELETE", `/roles/${id}`); },
  setRoleStatus(id, status) { return request("PUT", `/roles/${id}/status`, { status }); },
  replacePermissions(id, permissions) { return request("PUT", `/roles/${id}/permissions`, { permissions }); },
  membersOfRole(id) { return request("GET", `/roles/${id}/members`); },

  // —— 员工-角色 ——
  rolesForEmployee(employeeId) { return request("GET", `/employees/${employeeId}/roles`); },
  assignRole(employeeId, roleId) { return request("PUT", `/employees/${employeeId}/roles/${roleId}`); },
  unassignRole(employeeId, roleId) { return request("DELETE", `/employees/${employeeId}/roles/${roleId}`); },

  // —— 访问上下文 ——
  myAccess() { return request("GET", "/employees/me/access"); },
  myContext() { return request("GET", "/employees/me/context"); },
  employeeAccess(employeeId) { return request("GET", `/employees/${employeeId}/access`); },
  checkPermission(employeeId, permissionCode) { return request("GET", `/employees/${employeeId}/permissions/${permissionCode}`); }
};



// WEBPACK FOOTER //
// ./src/api/identity.js